import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';

import { t } from '@ping/helpers';
import { governanceActionLabel, governanceStatusLabel } from '@ping/pages/user/business/governance-labels.utils';
import { governanceQueryKeysFor } from '@ping/pages/user/business/governance-refresh.utils';
import { Text, Toast } from '@ping/uikit';
import { useNotificationWS } from '@ping/websockets';
import { NotificationEvents } from '@ping/websockets/useNotificationWS';

import type { LinkProps } from 'next/link';

interface IGovernanceNotice {
  requestId?: string;
  RequestId?: string;
  actionType?: string;
  ActionType?: string;
  status?: string;
  Status?: string;
}

export const GovernanceRequestNotice = () => {
  const { subscribe } = useNotificationWS();
  const queryClient = useQueryClient();
  const queryClientRef = useRef(queryClient);
  queryClientRef.current = queryClient;

  useEffect(() => {
    subscribe<IGovernanceNotice | string>(NotificationEvents.OnGovernanceRequestStatusChanged, message => {
      const notice = typeof message === 'string' ? (JSON.parse(message) as IGovernanceNotice) : message;
      const requestId = notice?.requestId || notice?.RequestId;
      const actionType = notice?.actionType || notice?.ActionType || '';
      const status = notice?.status || notice?.Status || '';
      governanceQueryKeysFor(actionType).forEach(queryKey => {
        queryClientRef.current.invalidateQueries(queryKey);
      });
      if (!requestId) {
        return;
      }

      const href = `/user/business/approvals/pending?requestId=${requestId}`;
      Toast.success({
        title: (
          <span>
            <Text body='regular'>
              {t(governanceActionLabel(actionType))} · {t(governanceStatusLabel(status))}
            </Text>{' '}
            <Link href={href as LinkProps['href']}>
              <a>{t('Open this request')}</a>
            </Link>
          </span>
        ),
      });
    });
  }, [subscribe]);

  return null;
};
